export const notepadModule = {
  namespaced: true,
  state: {
    notes: [
      {
        id: 0,
        title: "",
        note: ""
      }
    ],
    nextId: 1  
  },
  getters: {
    getNotes(state) {
      return state.notes
    }
  },
  mutations: {
    loadNotes (state) {
      if (localStorage.getItem('notes') === null || JSON.parse(localStorage.getItem('notes')).length == 0) {
        state.notes = []
      } else {
        state.notes = JSON.parse(localStorage.getItem('notes'))
        let currentLastId = Math.max.apply(Math, state.notes.map(function(o) { return o.id; }))
        state.nextId = ++currentLastId
      }
      
    },
    setNotes (state, payload) {
      state.notes = payload
      localStorage.setItem('notes', JSON.stringify(payload))
    },
    addNote (state, payload) {
      let title = ( payload.name? payload.name : "")

      state.notes.push({
        ...{title: title, note:""},
        id: state.nextId++
      })
    },
    deleteNote(state, toRemove) {
      state.notes = state.notes.filter(
        notification => notification.id !== toRemove.id
      )
    }
  },
  actions: {
    loadNotes (context) {
      context.commit('loadNotes')
    },
    setNotes (context, payload) {
      context.commit('setNotes', payload)
    },
    addNote (context, payload) {
      context.commit('addNote', payload)
    },
    removeNote (context, payload) {
      context.commit('deleteNote', payload)
      context.commit('setNotes', context.state.notes)
    }
  }
}